import { render, staticRenderFns } from "./ChapterList.vue?vue&type=template&id=48c677f4&scoped=true"
import script from "./ChapterList.vue?vue&type=script&lang=js"
export * from "./ChapterList.vue?vue&type=script&lang=js"
import style0 from "./ChapterList.vue?vue&type=style&index=0&id=48c677f4&prod&lang=scss&scoped=true"
import style1 from "./ChapterList.vue?vue&type=style&index=1&id=48c677f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c677f4",
  null
  
)

export default component.exports